var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-handshake-outline" } }, [
        _vm._v("Acuerdos de servicio para la atención de solicitudes")
      ]),
      _c(
        "v-fade-transition",
        [
          _vm.isLoading
            ? _c(
                "v-row",
                { staticClass: "my-4" },
                _vm._l(6, function(k) {
                  return _c(
                    "v-col",
                    { key: k, attrs: { cols: "12", md: "6", lg: "4" } },
                    [
                      _c("v-skeleton-loader", {
                        attrs: { height: "110", loading: "", type: "image" }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "v-row",
                { staticClass: "my-4" },
                _vm._l(_vm.view.guides, function(guide, k) {
                  return _c(
                    "v-col",
                    { key: k, attrs: { cols: "12", md: "6", lg: "4" } },
                    [
                      _c("info-file-box", {
                        attrs: {
                          file: guide,
                          "download-file-function": _vm.openFile,
                          "delete-file-function": _vm.deleteFile
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
        ],
        1
      ),
      !_vm.isLoading && _vm.isEmpty
        ? _c(
            "v-container",
            {
              staticClass: "empty-state",
              attrs: {
                "pa-0": "",
                "ma-0": "",
                fluid: "",
                "justify-center": "",
                "fill-height": ""
              }
            },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/empty-state-reports.png"),
                    alt: "No hay informes para listar"
                  }
                }),
                _c("p", [
                  _vm._v("No hay información disponible en este momento")
                ])
              ])
            ]
          )
        : _vm._e(),
      _c(
        "base-modal",
        {
          ref: "modal",
          attrs: {
            icon: "mdi-alert-outline",
            title: "Confirmación de eliminación"
          }
        },
        [
          _c(
            "v-col",
            { staticClass: "text-center" },
            [
              _c("div", { staticClass: "pb-6 pt-2 px-4 override-question" }, [
                _vm._v(" ¿Está seguro de querer eliminar el documento? ")
              ]),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "mr-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            color: "green",
                            dark: "",
                            loading: _vm.loadingDelete
                          },
                          on: {
                            click: function() {
                              return _vm.executeDelete()
                            }
                          }
                        },
                        [_vm._v("SÍ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            outlined: "",
                            disabled: _vm.loadingDelete,
                            color: "green"
                          },
                          on: {
                            click: function() {
                              this$1.$refs.modal.closeModal()
                            }
                          }
                        },
                        [_vm._v("NO")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }